import { render, staticRenderFns } from "./refundPolicy.vue?vue&type=template&id=baf2abde&"
import script from "./refundPolicy.vue?vue&type=script&lang=js&"
export * from "./refundPolicy.vue?vue&type=script&lang=js&"
import style0 from "./refundPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports